export default __webpack_public_path__ + "static/media/more-view-arrow.c572649d.svg";